const URL_BASE = 'https://www.cian.ru';

export function parseUtmParameter(url: string | undefined, parameter: string): string | null {
  if (!url) {
    return null;
  }

  return new URL(url, URL_BASE).searchParams.get(parameter);
}
